import { useRef, useState } from "react";
import api from "@/lib/api";
import AuthImage from "@/components/AuthImage";
import { Button } from "@/components/ui/button";
import { Camera, Upload, Trash2, Eye, Loader2, RefreshCw } from "lucide-react";
import { toast } from "sonner";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Upload padrão de FOTO. PC: seleciona arquivo. Celular/PWA: câmera ou galeria.
// value = storage_path (string) | ""; onChange(path|null)
export default function ImageUpload({ value, onChange, label = "Foto", testid = "image-upload" }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = () => inputRef.current?.click();

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!file.type.startsWith("image/")) return toast.error("Selecione uma imagem");
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.path);
      toast.success("Foto enviada");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Falha no envio");
    } finally { setBusy(false); }
  };

  const view = () => {
    const token = localStorage.getItem("nexolog_token");
    window.open(`${BACKEND}/api/files/${value}?auth=${token}`, "_blank");
  };

  const remove = async () => {
    try { await api.delete(`/files/${value}`); } catch { /* ignora */ }
    onChange(null);
  };

  return (
    <div data-testid={testid}>
      {label && <div className="text-sm font-medium mb-1.5">{label}</div>}
      <input ref={inputRef} type="file" accept="image/*" onChange={handleFile} className="hidden" data-testid={`${testid}-input`} />
      {value ? (
        <div className="flex items-center gap-3">
          <AuthImage path={value} className="w-20 h-20 rounded-md object-cover border border-border" alt={label} />
          <div className="flex flex-col gap-1.5">
            <div className="flex gap-1.5">
              <Button type="button" variant="outline" size="sm" onClick={view} data-testid={`${testid}-view`}><Eye className="w-4 h-4" /> Ver</Button>
              <Button type="button" variant="outline" size="sm" onClick={pick} disabled={busy} data-testid={`${testid}-replace`}>
                {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <RefreshCw className="w-4 h-4" />} Substituir
              </Button>
            </div>
            <Button type="button" variant="outline" size="sm" className="text-red-400 border-red-500/40" onClick={remove} data-testid={`${testid}-remove`}>
              <Trash2 className="w-4 h-4" /> Excluir
            </Button>
          </div>
        </div>
      ) : (
        <Button type="button" variant="outline" onClick={pick} disabled={busy} className="gap-2" data-testid={`${testid}-add`}>
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Camera className="w-4 h-4 sm:hidden" /><Upload className="w-4 h-4 hidden sm:block" /></>}
          Adicionar foto
        </Button>
      )}
    </div>
  );
}
